const riot = require('riot');

riot.tag2('module-user-select', '<div class="flex-fixed s-full p8 bg-white rounded-4 box-shadow hover-trigger hover-bg-label_pale transition"> <div class="text-label_low fs12 lh15 mb8">ユーザー</div> <label class="relative block"> <input class="input w-full pl22 pr14 py4 focus-primary focus-text-label_high fs12 bold" ref="user_select" riot-value="{currentUser ? currentUser.data.screen_name : app.store.currentUser.data.screen_name}" placeholder="ユーザー" onclick="{onOpenPopupSelect}" oninput="{userPopup ? debounceSearchUsers : onOpenPopupSelect}" onblur="{closeUserPopup}" onkeydown="{userPopup.selectionList.onKeyDown}"><img class="absolute l4 t7 block z1 s12 circle object-fit-cover mr8" if="{document.activeElement !== refs.user_select &amp;&amp; currentUser.data.screen_name !== &quot;all&quot;}" riot-src="{currentUser.data.icon_url}"><i class="absolute l4 t1 z1 icon-user fs15 text-label_medium mr4" if="{document.activeElement === refs.user_select || currentUser.data.screen_name === &quot;all&quot;}"></i><i class="icon-close absolute t4 r4 z1 text-label_medium fs12 cursor-pointer" if="{refs.user_select.value}" onclick="{onDeleteText}"></i> </label> </div>', '', '', function(opts) {
    this.setup = () => {
      this.currentUser = this.opts.currentUser;
    };

    this.onOpenPopupSelect = (e) => {

      if (this.userPopup) return;

      this.refs.user_select.select();
      this.userPopup = spat.popup.open('popup-select', {
        element: e.currentTarget,
        align: { x:'left' },
        offsetTop: 10,
        position: 'bottom',
        opts: {
          options: () => {return this.getSearchUsers(); },
          kind: 'user',
        },
      }).on('select', ({ option: user }) => {
        this.currentUser = user;
        this.refs.user_select.value = user.data.screen_name;
        this.update();
        this.trigger('select', user);
      }).on('close', () => {

        this.refs.user_select.blur();
        this.userPopup = null;
        this.update();
      });
      this.searchUsers();
    };

    this.closeUserPopup = () => {
      if (!this.userPopup) return;
      if (this.refs.user_select) {
        this.userPopup.selectCurrent();
      }
      else {
        this.userPopup.close();
      }
    };

    this.getSearchUsers = () => {
      var users = this.refs.user_select.value ? this.displayUsers : this.opts.users;
      return  users;
    };

    this.searchUsers = () => {
      if (!this.userPopup) return ;
      const value = this.refs.user_select.value;
      const keyword = value.toLowerCase();
      this.displayUsers = this.opts.users.map(user => {
        const index = user.data.screen_name.toLowerCase().indexOf(keyword);
        return { index, user };
      }).filter(item => item.index >= 0).sort((a, b) => a.index - b.index).map(item => item.user);
      this.update();
      this.userPopup.setItems();
      this.userPopup.update();
    };

    this.debounceSearchUsers = _.debounce(() => {
      this.searchUsers();
    }, 64);

    this.onDeleteText = () => {
      this.refs.user_select.value = '';
      this.update();
    };
});